import addSponsor from "./addSponsor";
import removeSponsor from "./removeSponsor";
import searchUsers from "./searchUsers";
import { api } from "../../api";

export const sponsorsApi = api.injectEndpoints({
  endpoints: (build) => ({
    addSponsor: addSponsor(build),
    removeSponsor: removeSponsor(build),
    searchUsers: searchUsers(build),
  }),
  overrideExisting: true,
});

export const {
  useAddSponsorMutation,
  useRemoveSponsorMutation,
  useLazySearchUsersQuery,
} = sponsorsApi;
